import React from 'react';
import { Download, Share2 } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { useI18n } from '../i18n/I18nProvider';

const W = 1080, H = 1350;

function wrap(ctx, text, maxW) {
  const lines = []; let line = '';
  text.split(' ').forEach((w) => {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = w; } else line = test;
  });
  if (line) lines.push(line);
  return lines;
}

const loadImg = (src) => new Promise((res) => { const i = new Image(); i.onload = () => res(i); i.onerror = () => res(null); i.src = src; });

async function renderCard(statement) {
  await document.fonts.ready;
  const c = document.createElement('canvas'); c.width = W; c.height = H;
  const ctx = c.getContext('2d');
  ctx.fillStyle = '#1f3a2a'; ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = 'rgba(212,166,61,0.55)'; ctx.lineWidth = 3; ctx.strokeRect(50, 50, W - 100, H - 100);
  const logo = await loadImg('/favicon-plant-transparent.png');
  if (logo) ctx.drawImage(logo, 110, 120, 110, 110);
  ctx.fillStyle = '#d4a63d'; ctx.font = '600 30px Inter, sans-serif';
  ctx.fillText(statement.label.toUpperCase().split('').join(' '), 110, 330);
  ctx.fillStyle = '#f5efe3'; ctx.font = '400 66px Fraunces, Georgia, serif';
  const lines = wrap(ctx, statement.text, W - 220);
  lines.forEach((l, i) => ctx.fillText(l, 110, 440 + i * 86));
  ctx.fillStyle = 'rgba(245,239,227,0.7)'; ctx.font = 'italic 400 34px Fraunces, Georgia, serif';
  ctx.fillText('Psalm 1:3', 110, H - 190);
  ctx.fillStyle = '#d4a63d'; ctx.font = '600 30px Inter, sans-serif';
  ctx.fillText('PLANTED MINISTRIES', 110, H - 130);
  return new Promise((res) => c.toBlob(res, 'image/png'));
}

export default function ShareVisionCard({ statement }) {
  const { t } = useI18n();
  const { toast } = useToast();
  const file = async () => new File([await renderCard(statement)], 'planted-vision.png', { type: 'image/png' });

  const download = async () => {
    const f = await file();
    const a = document.createElement('a'); a.href = URL.createObjectURL(f); a.download = f.name; a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
    toast({ title: t.shareCard.okTitle, description: t.shareCard.okText });
  };

  const share = async () => {
    const f = await file();
    const payload = { title: t.shareCard.shareTitle, text: `${statement.label}: ${statement.text}`, url: window.location.origin };
    try {
      if (navigator.canShare && navigator.canShare({ files: [f] })) await navigator.share({ ...payload, files: [f] });
      else if (navigator.share) await navigator.share(payload);
      else await download();
    } catch (_) { /* user cancelled */ }
  };

  const btn = 'inline-flex items-center gap-2 rounded-full h-10 px-4 text-sm font-medium transition-colors';
  return (
    <div className="mt-6 flex flex-wrap gap-3">
      <button type="button" onClick={download} data-testid="vision-card-download-btn" className={`${btn} bg-[#d4a63d] hover:bg-[#b88a2a] text-[#1f3a2a]`}><Download size={15} /> {t.shareCard.download}</button>
      <button type="button" onClick={share} data-testid="vision-card-share-btn" className={`${btn} border border-[#f5efe3]/30 text-[#f5efe3] hover:bg-[#f5efe3]/10`}><Share2 size={15} /> {t.shareCard.share}</button>
    </div>
  );
}
